import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./dashboard";
import Evaluation from "./evaluation";
import Test from "./test";

export default function Tracker() {
  return (
    <div className="bg-white h-full flex flex-col">
      <div className="flex-1 overflow-auto">
        <Routes>
          <Route path="/" element={<Navigate to="in-training" replace />} />
          <Route path="/in-training" element={<Dashboard status="in_training" />} />
          <Route path="/ready-for-evaluation" element={<Dashboard status="ready_for_evaluation" />} />
          <Route path="/graduated" element={<Dashboard status="graduated" />} />
          <Route path="/evaluate/:id" element={<Evaluation />} />
          <Route path="/test/:id" element={<Test />} />
        </Routes>
      </div>
    </div>
  );
}
